import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import cohortMeetingWhite from "../../../../../assets/svg/cohortMeeting.svg";
import startupMiniCircle from "../../../../../assets/svg/startupMiniCircle.svg";
import { useHistory } from "react-router-dom";
import ModalVisible from "../CohortGroupSession/Modal/modal";
import CohortSummaryModal from "../../../../common/cohortSummaryModal";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import "./style.scss";
import arrow from "../../../../../assets/images/arrow.png";
import swal from "sweetalert";
import SessionGroupFeedbackModal from "../../../../common/groupSessionNotesModal";
import api from "../../../../common/dependencies/utils/Api";
import {
  InputBase,
  Grid,Box,
  Typography
} from "@material-ui/core";
import BasicModal from "../../../../common/summaryMentorModal/Modal";
import profile from "../../../../../assets/svg/cohortMeetingCircle.svg";
import {
  COHORT_NAME_LIST,
  GROUP_SESSION_NAME_LIST,
  MATCH_MENTOR_LIST,
} from "../../../../common/constants/ApplicationUrl";
import {
  getStepperTooltipData,
  getAdminDashCohortGraphData,
} from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import {
  listGroupSession,
  detailsGroupSession,
  invitedSessionMembersList,
  statusGroupSession,
  listGroupSessionCounter,
  cohortSessionNotesGiveFeedBack,
  cohortSessionNotesViewFeedBack,
  cohortGroupSessionHours,
  cohortGroupSessionHoursFilter,
} from "../dependencies/action";
import SessionsModal from "../../../../common/sessionsModal";
import AnimeList from "../../StartupDashboard/ViewAllMentorList/AnimeList";
import makeStyles from "@material-ui/core/styles/makeStyles";
import mentorMiniIcon from "../../../../../assets/svg/mentorsMiniCircle.svg";
import StarIcon from "../../../../../assets/svg/star.svg";
import createCohort from "../../../../../assets/images/Purple button Rectangle.svg";
import iconTooltip from "../../../../../assets/svg/dashboard/iconTooltip.svg";
import LineWithDot from "../../../../../assets/images/Line wit Dot.svg";
import Pagination from "react-js-pagination";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import { Country, State, City } from "country-state-city";

import { getPredefineOptionsList } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import * as moment from "moment";
import Select from "react-select";
import Button from "../../AdminDashboard/Button";
import {
  getNamesList,
  getCohortApplicationCounter,
} from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import * as momentzone from "moment-timezone";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "500px",
    paddingTop: "30px",
    paddingBottom: "150px",
    backgroundColor: "#f0f3f5",
    position: "relative",
  },
  headingOne: {
    fontSize: "28px",
    fontWeight: 600,
    fontFamily: "Montserrat",
    color: "#3e4a59",
  },
  headingTwo: {
    color: "rgba(86, 58, 150, 1)",
    fontSize: "40px",
    fontWeight: "600",
    fontFamily: "Montserrat",
  },
  requestsStatusTy: {
    backgroundColor: "#816aaf",
    color: "white",
    fontFamily: "Montserrat",
    padding: "10px 10px",
    borderRadius: "8px",
    fontWeight: 600,
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  rightRotated: { transform: "rotate(-90deg)" },
  upperDisplay: {
    width: "86%",
    marginTop: "25px",
    padding: "25px 50px",
    background:
      "linear-gradient(90deg, rgba(222, 212, 245,0.8130602582830007) 0%, rgba(247,243,255,1) 100%)",
  },
  messageIconWrapper: {
    height: "100%",
    display: "flex",
    justifyContent: "left",
    alignItems: "center",
    borderRadius: "px",
  },
  lineWithDotContainer: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      margin: "15px 0",
    },
  },
  lineWithDotUpper: {
    color: "#277acc",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "16px",
  },
  lineWithDot: {
    maxWidth: "none",
    maxHeight: "none",
    width: "150px",
    height: "10px",
    marginLeft: 0,
  },
  lineWithDotLower: {
    color: "#816aaf",
    fontWeight: "bold",
    textAlign: "left",
    fontSize: "14px",
  },
  newMessageButtonWrapper: {
    display: "flex !important",
    justifyContent: "flex-end !important",
  },
  machines: {
    position: "absolute",
    height: "400px",
    bottom: 40,
    right: 20,
  },
  filterContainer2: {
    padding: "10px",
    display: "flex",
  },
  select: {
    fontSize: "16px",
    width: "100%",
    whiteSpace: "nowrap",
    textAlign: "left",
  },
  cursorOnHover: {
    "&:hover": {
      cursor: "pointer",
    },
    [theme.breakpoints.down("md")]: {
      margin: "15px 0",
    },
  },
  lowerButtonsContainer: {
    padding: "0 35%",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  sendRequestButton: {
    height: "88.0781px !important",
    maxWidth: "none",
  },
  tableContainer: {
    // padding: "10px 10px 20px 10px",
    margin: "0 7% 50px 7%",
  },
  upperDisplayButtonsContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  filterContainer: {
    padding: "40px 7% 0 7%",
    display: "flex",
    alignItems: "center",
  },
  selectContainer: {
    display: "flex",
    justifyContent: "right",
    [theme.breakpoints.down("md")]: {
      marginBottom: "10px",
    },
  },
  rightRotated: { transform: "rotate(-90deg)" },
}));
const CohortRecordingList = (props) => {
  const {
    getNamesList,
    getNamesListData,
    getCohortApplicationCounter,
    getTableCounterData,
    getTableData,
    listGroupSession,
    listGroupSessionPaginate,
    listGroupSessionData,
    detailsGroupSession,
    detailsGroupSessionData,
    cohortSessionNotesGiveFeedBack,
    cohortSessionNotesViewFeedBack,
    sessionFeedBackData,
    sessionNotesFeedBackData,
    cohortGroupSessionHoursData,
  } = props;
  const [activeText, setActiveText] = useState(false);
  const [activeText0, setActiveText0] = useState(false);
  const [activeText2, setActiveText2] = useState(false);
  const [allMentorList, setAllMentorList] = useState();
  const [allStartupList, setAllStartupList] = useState();
  const [activeText3, setActiveText3] = useState(false);
  const [activeText4, setActiveText4] = useState(false);
  const [activeText5, setActiveText5] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [selectedRow, setSelectedRow] = useState("");
  const [secondTable, setSecondTable] = useState("");
  const [mentorShipReqData, setMentorShipReqData] = useState();
  const [tableList, setTableList] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState();
  const history = useHistory();
  const [indexCounter, setIndexCounter] = useState(0);
  const [nameListValue, setNameListValue] = useState([]);
  const [sessionHoursBtnPressed, setSessionHoursBtnPressed] = useState(false);
  const [mentorFeedbackModalOpen, setMentorFeedbackModalOpen] = useState(false);
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [filterName, setFilterName] = useState("");
  const [filterNameValue, setFilterNameValue] = useState("");
  const [filterCohortname, setFilterCohortname] = useState("");
  const [filterCohortId, setFilterCohortId] = useState("");
  const [cohortnameList, setcohortnameList] = useState([]);
  const [cohortnameId, setcohortnameId] = useState([]);
  const classes = useStyles();
  const [sessionModalData, setSessionModalData] = useState(null);
  const [sessionModalOpen, setSessionModalOpen] = useState(false);
  const [editModalVisibility, setEditModalVisibility] = useState(false);
  const [sessionModalChild, setSessionModalChild] = useState(false);
  const html = document.getElementsByTagName("html")[0];
  const [cohortGroupSessionId, setCohortGroupSessionId] = useState("");
  const [cohortAdminId, setCohortAdminId] = useState("");
  const [cohortGroupSessionList, setCohortGroupSessionList] = useState([]);
  const [searchCohortId, setSearchCohortId] = useState("");
  const [feedbackMode, setFeedbackMode] = useState(false);
  const [clipBoardImgShow, setClipBoardImgShow] = useState("");
  const [showVideo, setShowVideo] = useState();
  const [videoUrl, setVideoUrl] = useState();
  const [newCohortid, setNewCohortid] = useState();
  const [clickModaldata, setClickmodaldata] = useState([]);
  const sampleData = {
    sno: 1,
    cohortName: "Green Revolution",
    startDate: "03/05/2023",
    organization_name: "JP Morgan",
    applicationStatus: "VERIFIED",
    duration: 12,
  };
  const sampleArr = [];
  sampleArr.push(sampleData);
  useEffect(() => {
    let params = {
      userId: "62bad31b7d5e35739a427d14",
      fromInvitationList: false,
      sessionStatus: selectedStatus,
      pageFilter: {
        pageSize: 10,
        currentPage: 0,
      },
    };
    listGroupSession(params);
  }, []);

  const handleLoginClick = () => {
    localStorage.setItem("path", "path");
    history.push({
      pathname: "/cohort-form",
      state: {
        fromPage: "cohort-application",
      },
    });
  };
  const [modalVisibility, setModalVisibility] = useState(false);
  const [modalVisibility2, setModalVisibility2] = useState(false);
  // const [toggleMentor, setToggleMentor] = useState(false);

  const [fromModule, setFromModule] = useState("");
  const defaultFormData = {
    search: "",
    industry: null,
    specialization: null,
    stage: null,
    recognized: "",
    state: "",
    country: "",
  };

  const newCountryArray = [];
  const newStateArray = [];
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [timeErrorBoolean, setTimeErrorBoolean] = useState(false);
  const [error, setError] = useState();
  const [timeError, setTimeError] = useState();
  const [selectedStatus, setSelectedStatus] = useState("");
  const [formData, setFormData] = useState(defaultFormData);
  const [newCountryOptions, setNewCountryOptions] = useState(newCountryArray);
  const [newStateOptions, setNewStateOptions] = useState(newStateArray);
  const [newCountrySelect, setNewCountrySelect] = useState(false);
  const [allMentorNames, setAllMentorNames] = useState();
  const [filterIndustry, setFilterIndustry] = useState("");
  const [filterFunction, setFilterFunction] = useState("");
  const [filterStage, setFilterStage] = useState("");
  const [filterState, setFilterState] = useState("");
  const [filterCountry, setFilterCountry] = useState("");
  const [cohortfilterGo, setcohortfilterGo] = useState(false);
  const [taggingList, setTaggingList] = useState([]);
  const [Heading, setHeading] = useState();
  const [InstructionswithRole, setInstructionswithRole] = useState();
  const [SelectPage, setSelectPage] = useState();
  const [isShown, setIsShown] = useState(false);
  const [linkToggleCopy, setLinkToogleCopy] = useState(false);
  const [refreshPage, setRefreshPage] = useState(false);
  const [sessionMomModalOpen, setSessionMomModalOpen] = useState(false);
  const [sessionMomChildData, setSessionMomChildData] = useState("");
  const [canDelete,setCanDelete] = useState(false);
  const [videoArr, setVideoArr] = useState([]);
  const [linkToggleText, setLinkToogleText] = useState(
    "Click to Copy MAAARG session Link"
  );
  const selectInputRef = useRef();

  const loggedIn = JSON.parse(localStorage.getItem("SavedLoggedInData"));
  const setModalIsOpenToTrue = () => {
    setIsShown(!isShown);
  };
  const {
    getStartupApplication,
    startUpApplication,
    startUpApplicationPagineate,
    getCountersStartUpList,
    getCounterStartUp,
    getPredefineOptionsList,
    getPredefineOptions,
    getTableDataPaginate,
    getStepperTooltipData,
    getStepperData,
    invitedSessionMembersList,
    statusGroupSession,
    invitedSessionList,
    invitedSessionListPaginate,
    groupSessionCounter,
    listGroupSessionCounter,
    cohortGroupSessionHours,
    getAdminDashCohortGraphData,
    cohortCounterData,
    cohortGroupSessionHoursFilter,
    cohortGroupSessionHoursFilteredData,
  } = props;
  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));

  useEffect(() => {
    // axios({
    //   // url: GET_NAMES_DATA,
    //   url: GROUP_SESSION_NAME_LIST,
    //   method: "POST",
    //   data: {
    //     mentorId:
    //       localStorage.getItem("SavedLoggedInData") &&
    //       JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    //     listKey: "Mentor",
    //   },
    // })

    api
      .POST(GROUP_SESSION_NAME_LIST, {
        mentorId:
          localStorage.getItem("SavedLoggedInData") &&
          JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
        listKey: "Mentor",
      })
      .then((res) => {
        setAllMentorList(res.data?.data);
      })
      .catch((err) => {});

    // axios({
    //   url: GROUP_SESSION_NAME_LIST,
    //   method: "POST",
    //   data: {
    //     mentorId:
    //       localStorage.getItem("SavedLoggedInData") &&
    //       JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    //     listKey: "Startup",
    //   },
    // })
    api
      .POST(GROUP_SESSION_NAME_LIST, {
        mentorId:
          localStorage.getItem("SavedLoggedInData") &&
          JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
        listKey: "Startup",
      })
      .then((res) => {
        setAllStartupList(res.data?.data);
      })
      .catch((err) => {});
  }, []);

  const loginrole = JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role;
  // if (loginrole === "Mentor" || loginrole === "Admin") {
  //   localStorage.setItem("CohortRecordingList", "CohortRecordingList");
  // } else {
  //   localStorage.removeItem("CohortRecordingList");
  //   history.push("/startup-dashboard");
  // }

  useEffect(() => {
    html.style.overflow = "auto";

    // localStorage.setItem("CohortRecordingList", "CohortRecordingList");
    setTimeout(() => {
      localStorage.removeItem("mentorMentorships");
      localStorage.removeItem("cohortMentors");
      localStorage.removeItem("cohortStartup");
      localStorage.removeItem("myrequestMenu");
      localStorage.removeItem("startupListMentor");
      localStorage.removeItem("cohortAdminMentorships");
      localStorage.removeItem("CohortMentorRequest");
      localStorage.removeItem("cohortProgram");
      localStorage.removeItem("cohortMatchTable");
    }, 1000);
    localStorage.removeItem("path");
    // axios({
    //   url: COHORT_NAME_LIST,
    //   method: "post",
    //   data: {
    //     mentorId: loggedIn?.role === "Admin" ? "" : "62bad31b7d5e35739a427d14",
    //     status: "VERIFIED",
    //   },
    // })
    api
      .POST(COHORT_NAME_LIST, {
        mentorId: loggedIn?.role === "Admin" ? "" : "62bad31b7d5e35739a427d14",
        status: "VERIFIED",
      })
      .then((res) => {
        res.data.data &&
          res.data.data.map((item, index) => {
            if (index === 0) {
              let arr2 = {
                label: "Select Cohort Name",
                value: "select",
              };
              setcohortnameList((oldArray) => [...oldArray, arr2]);
            }
            if (item.name !== "" && item.name !== null) {
              let arr = {
                label: item.name,
                value: item.id,
              };
              if (res.data.data.length >= cohortnameList.length)
                setcohortnameList((oldArray) => [...oldArray, arr]);
            }
          });
      })
      .catch((err) => {});
    // axios({
    //   url: COHORT_NAME_LIST,
    //   method: "post",
    //   data: {
    //     status: "VERIFIED",
    //     mentorId: loggedIn?.role === "Admin" ? "" : "62bad31b7d5e35739a427d14",
    //   },
    // })
    api
      .POST(COHORT_NAME_LIST, {
        status: "VERIFIED",
        mentorId: loggedIn?.role === "Admin" ? "" : "62bad31b7d5e35739a427d14",
      })
      .then((res) => {
        res.data.data &&
          res.data.data.map((item, index) => {
            if (index === 0) {
              let arr2 = {
                label: "Select Cohort Id",
                value: "select",
              };
              setcohortnameId((oldArray) => [...oldArray, arr2]);
            }
            let arr = {
              label: `C${item.id.slice(-6)}`,
              value: item.id,
            };
            if (res.data.data.length >= cohortnameId.length)
              setcohortnameId((oldArray) => [...oldArray, arr]);
          });
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    setActiveText0(true);
    getTableDataStatus("");
    setSelectedStatus("");
  }, []);
  useEffect(() => {
    let params = {
      userId: loggedIn?.role === "Admin" ? "" : "62bad31b7d5e35739a427d14",
      fromInvitationList: false,
    };
    listGroupSessionCounter(params);
  }, []);
  useEffect(() => {
    getStepperTooltipData();
  }, []);
  useEffect(() => {
    if (linkToggleCopy) {
      setTimeout(() => {
        setLinkToogleCopy(false);
        setLinkToogleText("Click to join MAAARG session Link");
      }, 5000);
    }
  }, [linkToggleCopy]);
  useEffect(() => {
    setTimeout(() => {
      let params = {
        userId: "62bad31b7d5e35739a427d14",
        fromInvitationList: false,
        pageFilter: {
          pageSize: 10,
          currentPage: 0,
        },
      };
      listGroupSession(params);
      setRefreshPage(false);
      let params2 = {
        userId: loggedIn?.role === "Admin" ? "" : "62bad31b7d5e35739a427d14",
        fromInvitationList: false,
      };
      listGroupSessionCounter(params2);
      getGroupSessionFn();
      setActivePage(1);
    }, 1000);
  }, [refreshPage]);
  useEffect(() => {
    setHeading(getStepperData?.Guidedinstructions[0].Heading);
    setInstructionswithRole(
      getStepperData?.Guidedinstructions[0].InstructionswithRole
    );
    setSelectPage(getStepperData?.Guidedinstructions[0].SelectPage);
  }, [getStepperData]);
  useEffect(() => {
    let params = {
      listKey: "Startup",
    };
    getNamesList(params);
  }, []);
  const tableImageData = (key, id) => {
    return (
      <div
        style={{
          display: "flex",
        }}
        className="borderStartUp92221 removebordermobile"
      >
        <div
          className="newuserTooltip"
          style={{
            width: "100px",
            height: "100px",
            maxWidth: "none",
            objectFit: "contain",
          }}
        >
          <img
            src={key.image !== null && key.image !== "" ? key.image : hashImage}
            onClick={() => ViewProfile(key.username, key.id)}
            className="sidebar-dashboard-icon2 newWidthIconFIx"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              cursor: "pointer",
            }}
          />
          <span
            className="tooltiptext tooltip-bottom "
            style={{
              left: "46px",
              top: "94px",
              width: "150px",
            }}
          >
            View Mentor Profile
          </span>
        </div>

        <div
          style={{
            display: "flex",

            position: "absolute",
          }}
          className="borderStartUp92221 speakernamechrtgrpsessnmobile"
        >
          <div>{key.applicant_name}</div>
          <div>{"M" + key.id.substring(key?.id.length - 6)}</div>
          <div>{key.mentorTopic}</div>
          <div>{key.sessionTime}</div>
          <div>{key.sessionDuration}</div>
          <div
            className="newuserTooltip listener20"
            style={{
              cursor: "pointer",
              padding: "6px",
              position: "absolute",
              right: "0px",
              marginLeft: "1rem",
              display: "flex",
              justifyContent: "end",
            }}
          >
            <img
              src={mentorMiniIcon}
              height={40}
              width={40}
              onClick={() => {
                ViewProfile(key.username, key?.id);
              }}
            />
            <span
              className="tooltiptext tooltip-bottom "
              style={{
                left: "40px",
                top: "50px",
                width: "150px",
              }}
            >
              View Mentor Profile
            </span>
          </div>
          {key?.isSessionNotesSubmitted ? (
            <div className="newuserTooltip viewnotesformbfixdata">
              <div
                className="color-green"
                style={{ width: "fit-content", cursor: "pointer" }}
                onClick={() => {
                  setFeedbackMode(true);
                  let params = {
                    cohortGroupSessionId: id,
                    addedBy: key?.id,
                  };
                  cohortSessionNotesViewFeedBack(params);
                  getSessionDetails(key?.cohortGroupSessionId);
                  setTimeout(() => {
                    setSessionMomModalOpen(true);
                  }, 2000);
                }}
              >
                View Notes
              </div>
              <span
                className="tooltiptext tooltip-bottom "
                style={{
                  left: "2rem",
                  top: "2.4rem",
                  width: "150px",
                }}
              >
                View Session Notes
              </span>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  };
  const tableSpeakerData = (key, groupId, index) => {
    return (
      <>
        <div
          style={{
            display: "flex",
          }}
          className="borderStartUp92221"
        >
          <div>SPEAKER : {index + 1} </div>
          <div>{key.applicant_name}</div>
          <div>{"M" + key.id.substring(key?.id.length - 6)}</div>
          <div>{key.mentorTopic}</div>
          <div>{key.sessionTime}</div>
          <div>{key.sessionDuration}</div>
          <div
            className="newuserTooltip"
            style={{
              cursor: "pointer",
              padding: "6px",
              position: "absolute",
              right: "0px",
              bottom: "0px",
            }}
          >
            <img
              src={mentorMiniIcon}
              height={40}
              width={40}
              onClick={() => {
                ViewProfile(key.username, key?.id);
              }}
            />
            <span
              className="tooltiptext tooltip-bottom "
              style={{
                left: "40px",
                top: "50px",
                width: "150px",
              }}
            >
              View Mentor Profile
            </span>
          </div>
          {key?.isSessionNotesSubmitted === true ? (
            <div className="newuserTooltip">
              <div
                className="color-green"
                style={{ width: "fit-content", cursor: "pointer" }}
                onClick={() => {
                  setFeedbackMode(true);
                  let params = {
                    cohortGroupSessionId: groupId,
                    addedBy: key?.id,
                  };
                  cohortSessionNotesViewFeedBack(params);
                  getSessionDetails(key?.cohortGroupSessionId);
                  setTimeout(() => {
                    setSessionMomModalOpen(true);
                  }, 2000);
                }}
              >
                View Notes
              </div>
              <span
                className="tooltiptext tooltip-bottom "
                style={{
                  left: "2rem",
                  top: "2.4rem",
                  width: "150px",
                }}
              >
                View Session Notes
              </span>
            </div>
          ) : (
            ""
          )}
        </div>
      </>
    );
  };
  const tableSpeakerRow = (item, groupId) => {
    return (
      <>
        {item !== undefined &&
          item.map(function (key, index) {
            if (
              // toggleMentor &&
              item.length > 1 &&
              cohortGroupSessionList.find((element) => element === groupId) !==
                undefined
            )
              return (
                <>
                  {index < 2 ? tableSpeakerData(key, groupId, index) : ""}
                  {index === item.length - 1 ? (
                    <>
                      <td
                        className=""
                        style={{
                          // borderTop: "1px solid lightgray",
                          minWidth: "10.4rem",
                        }}
                      ></td>
                    </>
                  ) : (
                    ""
                  )}
                </>
              );
            else
              return (
                <>
                  {tableSpeakerData(key, groupId, index)}
                  {index === item.length - 1 && item.length > 1 ? (
                    <>
                      <td
                        className=""
                        style={{
                          // borderTop: "1px solid lightgray",
                          minWidth: "10.4rem",
                        }}
                      ></td>
                    </>
                  ) : (
                    ""
                  )}
                </>
              );
          })}
      </>
    );
  };

  const tableImageRow = (item, id) => {
    return (
      <>
        {item !== undefined &&
          item.map(function (key, index) {
            if (
              // toggleMentor &&
              item.length > 1 &&
              cohortGroupSessionList.find((element) => element === id) !==
                undefined
            )
              return (
                <>
                  {index < 2 ? tableImageData(key, id) : ""}
                  {index === item.length - 1 && index !== 1 ? (
                    <>
                      {/* <td className=""> */}
                      <div
                        className="d-flex"
                        onClick={() => {
                          setCohortGroupSessionId("");
                          let sample = [];
                          sample = cohortGroupSessionList;
                          sample = sample.filter(function (item) {
                            return item !== id;
                          });
                          setCohortGroupSessionList(sample);
                        }}
                      >
                        <div
                          className="color-green21"
                          style={{
                            position: "relative",
                            left: "-0.35rem",
                            top: "-0.1rem",
                            whiteSpace: "nowrap",
                            margin: "0.75rem",
                          }}
                        >
                          View More
                        </div>
                        <div
                          style={{
                            cursor: "pointer",
                            bottom: "0.5rem",
                            right: "1.25rem",
                            marginLeft: "0.5rem",
                          }}
                          className="arrowCollapse"
                        >
                          <img
                            style={{
                              width: "45%",
                              marginRight: "1.25rem",
                              left: "0.5rem",
                              top: "0rem",
                              position: "relative",
                            }}
                            src={arrow}
                          />
                        </div>
                      </div>
                      {/* </td> */}
                    </>
                  ) : (
                    ""
                  )}
                </>
              );
            else
              return (
                <>
                  {tableImageData(key, id)}
                  {index === item.length - 1 &&
                  item.length > 1 &&
                  index !== 1 ? (
                    <>
                      {/* <td className=""> */}
                      <div
                        className="d-flex"
                        onClick={() => {
                          setCohortGroupSessionId(id);
                          if (
                            cohortGroupSessionList.find(
                              (element) => element === id
                            ) === undefined
                          )
                            setCohortGroupSessionList((listData) => [
                              ...listData,
                              id,
                            ]);
                          else {
                            let sample = [];
                            sample = cohortGroupSessionId;
                            sample = sample.filter(function (item) {
                              return item !== id;
                            });
                            setCohortGroupSessionList(sample);
                          }
                        }}
                      >
                        <div
                          className="color-green21"
                          style={{
                            position: "relative",
                            left: "-0.35rem",
                            top: "-0.1rem",
                            whiteSpace: "nowrap",
                            margin: "0.75rem",
                          }}
                        >
                          View Less
                        </div>
                        <div
                          style={{
                            cursor: "pointer",
                            bottom: "0.5rem",
                            right: "1.25rem",
                            marginLeft: "0.95rem",
                          }}
                          className="arrowCollapse"
                        >
                          <img
                            style={{
                              width: "50%",
                              marginRight: "2.5rem",
                              left: "0.5rem",
                              position: "relative",
                              transform: "rotate(270deg)",
                            }}
                            src={arrow}
                          />
                        </div>
                      </div>
                      {/* </td> */}
                    </>
                  ) : (
                    ""
                  )}
                </>
              );
          })}
      </>
    );
  };

  useEffect(() => {
    getNamesListData?.forEach((element, index) => {
      if (index === 0) {
        let arr2 = {
          value: "Select",
          label: "Select Startup",
        };
        setNameListValue((oldArray) => [...oldArray, arr2]);
      }
      let arr = {
        value: element.id,
        label: element.name,
      };
      if (getNamesListData.length >= nameListValue.length)
        setNameListValue((oldArray) => [...oldArray, arr]);
    });
  }, [getNamesListData]);
  useEffect(() => {
    let params = {
      mentorId: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    };
    getCohortApplicationCounter(params);
    getGroupSessionFn();
  }, []);
  const getGroupSessionFn = () => {
    let sessionData = JSON.parse(localStorage.getItem("SavedLoggedInData"));
    let params2 = {
      status: "VERIFIED",
      sortKey: "name",
      sortOrder: "ASC",
      country: null,
      state: null,
      industry: null,
      function: null,
      stage: null,
      searchField: sessionData?.role === "Admin" ? null : sessionData?.id,
      searchKey: null,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "date_applied",
        sortOrder: "DESC",
      },
    };
    cohortGroupSessionHours(params2);
    let params3 = {
      status: "VERIFIED",
      sortKey: "name",
      sortOrder: "ASC",
      country: null,
      state: null,
      industry: null,
      function: null,
      stage: null,
      searchField: null,
      searchKey: null,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "date_applied",
        sortOrder: "DESC",
      },
    };
    getAdminDashCohortGraphData(params3);
  };
  useEffect(() => {
    // console.log("cohortGroupSessionHoursData", cohortGroupSessionHoursData);
    if (
      cohortGroupSessionHoursData !== undefined &&
      cohortGroupSessionHoursData !== null
    ) {
      setSecondTable(cohortGroupSessionHoursData);
    }
  }, [cohortGroupSessionHoursData]);
  useEffect(() => {
    if (
      cohortGroupSessionHoursFilteredData !== undefined &&
      cohortGroupSessionHoursFilteredData !== null
    ) {
      // Total Cohort Applications : {secondTable?.paginate?.totalElements}{" "}
      // &lt; {secondTable?.paginate?.currentPage} of{" "}
      // {secondTable?.paginate?.numPages} &gt;{" "}
      let testObj = {
        id: cohortGroupSessionHoursFilteredData?.id,
        city: cohortGroupSessionHoursFilteredData?.city,
        country: cohortGroupSessionHoursFilteredData?.country,
        current_designation: cohortGroupSessionHoursFilteredData?.current_designation,
        disclaimer: cohortGroupSessionHoursFilteredData?.disclaimer,
        hoursperweek: cohortGroupSessionHoursFilteredData?.hoursperweek,
        linkedinurl: cohortGroupSessionHoursFilteredData?.linkedinurl,
        mentor_name: cohortGroupSessionHoursFilteredData?.mentor_name,
        mentorenrolmentid: cohortGroupSessionHoursFilteredData?.mentorenrolmentid,
        numberofmentors: cohortGroupSessionHoursFilteredData?.numberofmentors,
        numberofstartups: cohortGroupSessionHoursFilteredData?.numberofstartups,
        organization_name: cohortGroupSessionHoursFilteredData?.organization_name,
        personalblogurl: cohortGroupSessionHoursFilteredData?.personalblogurl,
        phone_number: cohortGroupSessionHoursFilteredData?.phone_number,
        program_desc:cohortGroupSessionHoursFilteredData?.program_desc,
        program_duration: cohortGroupSessionHoursFilteredData?.program_duration,
        program_duration_text: cohortGroupSessionHoursFilteredData?.program_duration_text,
        program_name: cohortGroupSessionHoursFilteredData?.program_name,
        specialization: cohortGroupSessionHoursFilteredData?.specialization,
        state: cohortGroupSessionHoursFilteredData?.state,
        uploadAttach:
        cohortGroupSessionHoursFilteredData?.uploadAttach,
        uploadLogo:
        cohortGroupSessionHoursFilteredData?.uploadLogo,
        uploadBanner:
        cohortGroupSessionHoursFilteredData?.uploadBanner,
        cohortId: cohortGroupSessionHoursFilteredData?.cohortId,
        applicationStatus: cohortGroupSessionHoursFilteredData?.applicationStatus,
        cohort_date: cohortGroupSessionHoursFilteredData?.cohort_date,
        startup_start_date: cohortGroupSessionHoursFilteredData?.startup_start_date,
        startup_end_date: cohortGroupSessionHoursFilteredData?.startup_end_date,
        organization_type: cohortGroupSessionHoursFilteredData?.organization_type,
        industry: cohortGroupSessionHoursFilteredData?.industry,
        preferred_stage: cohortGroupSessionHoursFilteredData?.preferred_stage,
        mentorId: cohortGroupSessionHoursFilteredData?.mentorId,
        date_applied: cohortGroupSessionHoursFilteredData?.date_applied,
        date_updated: cohortGroupSessionHoursFilteredData?.date_updated,
        comments: cohortGroupSessionHoursFilteredData?.comments,
        mentorEmail: cohortGroupSessionHoursFilteredData?.mentorEmail,
        applied: cohortGroupSessionHoursFilteredData?.applied,
        mentorsEngaged: cohortGroupSessionHoursFilteredData?.mentorsEngaged,
        startupsEngaged: cohortGroupSessionHoursFilteredData?.sessionsUpcoming,
        sessionsUpcoming: cohortGroupSessionHoursFilteredData?.sessionsUpcoming,
        mentorships: cohortGroupSessionHoursFilteredData?.mentorships,
        cohort: cohortGroupSessionHoursFilteredData?.cohort,
        totalSessions: cohortGroupSessionHoursFilteredData?.totalSessions,
        sessionsCompleted: cohortGroupSessionHoursFilteredData?.sessionsCompleted,
        sessionsScheduled: cohortGroupSessionHoursFilteredData?.sessionsUpcoming,
        total_with_all_status: cohortGroupSessionHoursFilteredData?.total_with_all_status,
        hoursTotal: cohortGroupSessionHoursFilteredData?.hoursTotal,
        hoursCompleted: cohortGroupSessionHoursFilteredData?.hoursCompleted,
        hoursScheduled: cohortGroupSessionHoursFilteredData?.hoursScheduled,
      };
      let newObj = {
        data: [testObj],
        paginate: {
          totalElements: 1,
          currentPage: 1,
          numPages: 1,
        },
      };
      setSecondTable(newObj);
    }
  }, [cohortGroupSessionHoursFilteredData]);

  const approvalOptions = [
    {
      value: "SCHEDULED",
      label: "SCHEDULED",
    },
    { value: "COMPLETED", label: "COMPLETED" },
  ];

  useEffect(() => {
    getPredefineOptionsList();
    Country.getAllCountries().map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newCountryArray.push(newObject);
      setNewCountryOptions(newCountryArray);
    });
    State.getStatesOfCountry("IN").map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newStateArray.push(newObject);
      setNewStateOptions(newStateArray);
    });
  }, []);
  const customStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "white",
      height: "35px",
      color: "#333",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        textAlign: "left",
        backgroundColor: isSelected
          ? "#b499c7"
          : isFocused
          ? "#e4d7ee"
          : "white",
        color: isSelected ? "white" : "black",
        cursor: isDisabled ? "not-allowed" : "default",
      };
    },
    menu: (base) => ({
      ...base,
      width: "max-content",
      minWidth: "100%",
      fontSize: "14px",
    }),
  };
  const customStyles2 = {
    placeholder: (provided, state) => ({
      ...provided,
      width: state.selectProps.width,
      borderBottom: "1px dotted pink",
      color: state.selectProps.menuColor,
      padding: 20,
      fontSize: "12px",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        textAlign: "left",
        backgroundColor: isSelected
          ? "#b499c7"
          : isFocused
          ? "#e4d7ee"
          : "white",
        color: isSelected ? "white" : "black",
        cursor: isDisabled ? "not-allowed" : "default",
      };
    },
  };
  useEffect(() => {
    getPredefineOptionsList();
  }, []);

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    let sessionData = JSON.parse(localStorage.getItem("SavedLoggedInData"));
    if (!sessionHoursBtnPressed) {
      let params
      if(searchCohortId !== "")
      {
        params = {
          userId: "62bad31b7d5e35739a427d14",
          fromInvitationList: false,
          sessionStatus: selectedStatus,
          cohortId: searchCohortId,
          pageFilter: {
            pageSize: 10,
            currentPage: pageNumber - 1,
          },
        };
        listGroupSession(params);
    }
      else {
        params = {
          userId: "62bad31b7d5e35739a427d14",
          fromInvitationList: false,
          sessionStatus: selectedStatus,
          pageFilter: {
            pageSize: 10,
            currentPage: pageNumber - 1,
          },
        };
        listGroupSession(params);
    }
    } else {
      let params2 = {
        status: "VERIFIED",
        sortKey: "name",
        sortOrder: "ASC",
        country: null,
        state: null,
        industry: null,
        function: null,
        stage: null,
        searchField: sessionData?.role === "Admin" ? null : sessionData?.id,
        searchKey: null,
        pageFilter: {
          currentPage: pageNumber - 1,
          includeCount: true,
          pageSize: 10,
          sortField: "date_applied",
          sortOrder: "DESC",
        },
      };
      cohortGroupSessionHours(params2);
    }
  };
  const getSessionDetails = (id) => {
    let params = {
      cohortGroupSessionId: id,
      userId: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    };
    detailsGroupSession(params);
  };
  useEffect(() => {
    if (detailsGroupSession !== undefined) {
      setSessionModalData(detailsGroupSessionData);
    }
  }, [detailsGroupSessionData]);

  useEffect(() => {
    setTableList(startUpApplication);
    let data = startUpApplication?.requestJson;
    setMentorShipReqData(data);
  }, [startUpApplication]);
  const getStartUpId = (string) => {
    const value = string.substring(string?.length - 6);
    return value;
  };
  const getTableDataStatus = (status) => {
    let params = {
      userId: "62bad31b7d5e35739a427d14",
      fromInvitationList: false,
      sessionStatus: status,
      pageFilter: {
        pageSize: 10,
        currentPage: 0,
      },
    };
    listGroupSession(params);
  };
  const getTableDataSearch = () => {
    if (sessionHoursBtnPressed) {
      if (
        formData?.cohortorgname?.value !== undefined &&
        formData?.cohortorgname?.value !== null &&
        formData?.cohortorgname?.value !== ""
      ) {
        setFormData((user) => {
          return {
            ...user,
            cohortId: null,
          };
        });
      }
      if (
        formData?.cohortId?.value !== undefined &&
        formData?.cohortId?.value !== null &&
        formData?.cohortId?.value !== ""
      ) {
        setFormData((user) => {
          return {
            ...user,
            cohortorgname: null,
          };
        });
      }
      if (searchCohortId === "") {
        getGroupSessionFn();
        setSearchCohortId("");
        setFormData((user) => {
          return {
            ...user,
            cohortorgname: null,
            cohortId: null,
          };
        });
      } else {
        let filterParams = {
          status: "VERIFIED",
          sortKey: "name",
          sortOrder: "ASC",
          country: null,
          state: null,
          industry: null,
          function: null,
          stage: null,
          searchField: null,
          cohortId: searchCohortId,
          searchKey: null,
          pageFilter: {
            currentPage: 0,
            includeCount: true,
            pageSize: 10,
            sortField: "date_applied",
            sortOrder: "DESC",
          },
        };
        cohortGroupSessionHoursFilter(filterParams);
      }
    } else {
      let params;
      if (searchCohortId === "") {
        params = {
          userId: "62bad31b7d5e35739a427d14",
          fromInvitationList: false,
          sessionStatus: selectedStatus,
          pageFilter: {
            pageSize: 10,
            currentPage: 0,
          },
        };
        listGroupSession(params);
      } else {
        params = {
          userId: "62bad31b7d5e35739a427d14",
          fromInvitationList: false,
          sessionStatus: selectedStatus,
          cohortId: searchCohortId,
          pageFilter: {
            pageSize: 10,
            currentPage: 0,
          },
        };
        listGroupSession(params);
      }
    }
  };
  const ViewProfile = (item, id) => {
    setSelectedRow(id);
    let reRoute = window.open(sample + `/mentor-profile/${item}`, "_blank");
    reRoute.id = item;
  };

  const onBroadcastSelectionChange = (item, checked) => {
    const isThere = taggingList.find((ele) => {
      if (ele == item.id) return true;
    });
    if (checked) {
      if (!isThere) {
        setTaggingList([...taggingList, item.id]);
      }
    } else {
      if (isThere) {
        let newArray = taggingList.filter((ele) => ele != item.id);
        setTaggingList(newArray);
      }
    }
  };

  const getListData = (id, userType) => {
    setCohortGroupSessionId(id);
    if (userType === "MENTOR") setFromModule("Mentor");
    else setFromModule("Startup");
    setModalOpen(true);
  };

  const [defaultValue, setDefaultValue] = useState({
    value: "SCHEDULED",
    label: "SCHEDULED",
  });

  const handleDateTimeCheck = (item, data) => {
    var today = new Date();

    // today = mm + "/" + dd + "/" + yyyy;
    // let testDate = moment(item?.sessionDate).format("DD/MM/YYYY");
    // var currentTime = new Date().toTimeString().slice(0, 5);

    let currentDay = parseFloat(today.getDate());
    let sessionDay = parseFloat(moment(item?.sessionDate).format("DD"));

    let currentMonth = parseFloat(today.getMonth() + 1);
    let sessionMonth = parseFloat(moment(item?.sessionDate).format("MM"));

    let currentYear = parseFloat(today.getFullYear());
    let sessionYear = parseFloat(moment(item?.sessionDate).format("YYYY"));

    let currentHour = parseFloat(today.getHours());
    let sessionHour =
      parseFloat(item.sessionTime.split(":")[0]) +
      parseFloat(item.sessionDuration) +
      1;
    let currentMinitus = parseFloat(today.getMinutes());
    let sessionMinutes = parseFloat(item.sessionTime.split(":")[1]);
    if (currentYear >= sessionYear) {
      if (currentYear == sessionYear && currentMonth >= sessionMonth) {
        if (currentMonth == sessionMonth && currentDay >= sessionDay) {
          if (currentDay == sessionDay && currentHour >= sessionHour) {
            if (currentHour == sessionHour && currentMinitus > sessionMinutes) {
              setFeedbackMode(false);
              setSessionMomModalOpen(true);
              setSessionMomChildData(data);
            } else {
              if (currentHour > sessionHour) {
                setFeedbackMode(false);
                setSessionMomModalOpen(true);
                setSessionMomChildData(data);
              } else {
                displaySwalWarning();
                let params = {
                  userId: "62bad31b7d5e35739a427d14",
                  fromInvitationList: false,
                  sessionStatus: selectedStatus,
                  pageFilter: {
                    pageSize: 10,
                    currentPage: 0,
                  },
                };
                listGroupSession(params);
              }
            }
          } else {
            if (currentDay > sessionDay) {
              setFeedbackMode(false);
              setSessionMomModalOpen(true);
              setSessionMomChildData(data);
            } else {
              displaySwalWarning();
              let params = {
                userId: "62bad31b7d5e35739a427d14",
                fromInvitationList: false,
                sessionStatus: selectedStatus,
                pageFilter: {
                  pageSize: 10,
                  currentPage: 0,
                },
              };
              listGroupSession(params);
            }
          }
        } else {
          if (currentMonth > sessionMonth) {
            setFeedbackMode(false);
            setSessionMomModalOpen(true);
            setSessionMomChildData(data);
          } else {
            displaySwalWarning();
            let params = {
              userId: "62bad31b7d5e35739a427d14",
              fromInvitationList: false,
              sessionStatus: selectedStatus,
              pageFilter: {
                pageSize: 10,
                currentPage: 0,
              },
            };
            listGroupSession(params);
          }
        }
      } else {
        if (currentYear > sessionYear) {
          setFeedbackMode(false);
          setSessionMomModalOpen(true);
          setSessionMomChildData(data);
        } else {
          displaySwalWarning();
          let params = {
            userId: "62bad31b7d5e35739a427d14",
            fromInvitationList: false,
            sessionStatus: selectedStatus,
            pageFilter: {
              pageSize: 10,
              currentPage: 0,
            },
          };
          listGroupSession(params);
        }
      }
    } else {
      if (currentYear > sessionYear) {
        setFeedbackMode(false);
        setSessionMomModalOpen(true);
        setSessionMomChildData(data);
      } else {
        displaySwalWarning();
        let params = {
          userId: "62bad31b7d5e35739a427d14",
          fromInvitationList: false,
          sessionStatus: selectedStatus,
          pageFilter: {
            pageSize: 10,
            currentPage: 0,
          },
        };
        listGroupSession(params);
      }
    }
  };
  const displaySwalWarning = () => {
    swal({
      title: "WARNING",
      text: `You Cannot Complete Session Before Scheduled Time`,
      icon: "info",
    });
    renderTable();
  };

  const onClear = () => {
    setDefaultValue({ value: "SCHEDULED", label: "SCHEDULED" }); // this will reset the selected value
  };
  useEffect(() => {
    if (sessionNotesFeedBackData !== undefined) {
      setSessionMomChildData(sessionNotesFeedBackData);
    }
  }, [sessionNotesFeedBackData]);

  const renderTable = () => {
    setTimeout(() => {
      let params = {
        userId: "62bad31b7d5e35739a427d14",
        fromInvitationList: false,
        sessionStatus: selectedStatus,
        pageFilter: {
          pageSize: 10,
          currentPage: 0,
        },
      };
      listGroupSession(params);
      let params2 = {
        userId: loggedIn?.role === "Admin" ? "" : "62bad31b7d5e35739a427d14",
        fromInvitationList: false,
      };
      listGroupSessionCounter(params2);
    }, 2000);
  };

  const newfunctionTime = (item) => {
    let currentYear = moment().format("YYYY");
    let currentMonth = moment().format("MM");
    let presentTime = moment(new Date()).format("DD-MM-YYYY HH:mm A");
    let sessionYear = moment(item?.sessionStartDate).format("YYYY");
    let sessionMonth = moment(item?.sessionStartDate).format("MM");
    let sessionTime = moment(item?.sessionStartDate);
    let sessionDuration = item?.sessionDuration;
    let sessionStartTime = moment(sessionTime).format("DD-MM-YYYY HH:mm A");
    let sessionStartTime1 = moment(sessionTime);
    let sessionDate = moment(item?.sessionStartDate).format("DD-MM-YYYY");
    let presentDate = moment().format("DD-MM-YYYY");
    let beforetime1 = moment(sessionStartTime1).subtract(60, "minutes").format("DD-MM-YYYY HH:mm A");
    // let beforetime1 = moment(sessionStartTime, "DD-MM-YYYY HH:mm A")
    //   .subtract(60, "minutes")
    //   .format("DD-MM-YYYY HH:mm A");
    let endTime = moment(sessionTime)
      .add(sessionDuration + 1, "hours")
      .format("DD-MM-YYYY HH:mm A");

    if (
      sessionYear > currentYear ||
      (sessionYear == currentYear && sessionMonth > currentMonth)
    ) {
      swal({
        title: "Meeting Not Started",
        text: `Cannot join meeting before scheduled time.`,
        icon: "error",
        // timer: 1500,
        // buttons: false,
      });
    } else if (currentMonth == sessionMonth) {
      if (presentDate > sessionDate) {
        swal({
          title: "Meeting Completed",
          text: `Cannot join a completed meeting.`,
          icon: "error",
          // timer: 1500,
          // buttons: false,
        });
      } else if (sessionDate === presentDate) {
        if (presentTime >= beforetime1 && endTime >= presentTime) {
          window.open(item?.vcUrl, "_blank");
        } else if (presentTime < beforetime1) {
          swal({
            title: "Meeting Not Started",
            text: `Cannot join meeting before scheduled time.`,
            icon: "error",
            // timer: 1500,
            // buttons: false,
          });
        } else {
          swal({
            title: "Scheduled Time Over",
            text: `You cannot join meeting.`,
            icon: "error",
            // timer: 1500,
            // buttons: false,
          });
        }
      } else {
        swal({
          title: "Meeting Not Started",
          text: `Cannot join meeting before scheduled time.`,
          icon: "error",
          // timer: 1500,
          // buttons: false,
        });
      }
    } else if (sessionYear < currentYear) {
      swal({
        title: "Scheduled Time Over",
        text: `You cannot join meeting.`,
        icon: "error",
        // timer: 1500,
        // buttons: false,
      });
    }

    // if (currentDateTime < beforetime) {
    //   swal({
    //     title: "Meeting Not Started",
    //     text: `Cannot join meeting before scheduled time.`,
    //     icon: "error",
    //     // timer: 1500,
    //     // buttons: false,
    //   });
    // } else if (currentDateTime > aftertime) {
    //   if (sessionStatus === "SCHEDULED") {
    //     swal({
    //       title: "Scheduled Time Over",
    //       text: `You cannot join meeting.`,
    //       icon: "error",
    //       // timer: 1500,
    //       // buttons: false,
    //     });
    //   } else {
    //     swal({
    //       title: "Meeting Completed",
    //       text: `Cannot join a completed meeting.`,
    //       icon: "error",
    //       // timer: 1500,
    //       // buttons: false,
    //     });
    //   }
    // } else {
    //   window.open(item?.vcUrl, "_blank");
    // }

    // if (currentDateTime > aftertime) {

    //   if (sessionStatus === "SCHEDULED") {
    //     swal({
    //       title: "Scheduled Time Over",
    //       text: `You cannot join meeting.`,
    //       icon: "error",
    //       // timer: 1500,
    //       // buttons: false,
    //     });
    //   } else {
    //     swal({
    //       title: "Meeting Completed",
    //       text: `Cannot join a completed meeting.`,
    //       icon: "error",
    //       // timer: 1500,
    //       // buttons: false,
    //     });
    //   }
    // } else if (
    //   // currentDateTime > sessionTime ||
    //   currentDateTime <= aftertime ||
    //   currentDateTime == sessionStartDate ||
    //   currentDateTime >= beforetime
    // ) {
    //   window.open(item?.vcUrl, "_blank");
    // } else {
    //   swal({
    //     title: "Meeting hasn't commenced",
    //     text: `Cannot join meeting before scheduled time.`,
    //     icon: "error",
    //     // timer: 1500,
    //     // buttons: false,
    //   });
    // }
  };
  // useEffect(()=>{
  //   setTimeout(()=>{
  //     getGroupSessionFn()
  //   },1500)
  // },[scheduleModalOpen])
  const testSessionTextVisibility = (item) => {
    let currentYear = moment().format("YYYY");
    let currentMonth = moment().format("MM");
    let presentTime = moment(new Date()).format("DD-MM-YYYY HH:mm A");
    let sessionYear = moment(item?.sessionStartDate).format("YYYY");
    let sessionMonth = moment(item?.sessionStartDate).format("MM");
    let sessionTime = moment(item?.sessionStartDate);
    let sessionDuration = item?.sessionDuration;
    let sessionStartTime = moment(sessionTime).format("DD-MM-YYYY HH:mm A");
    let sessionDate = moment(item?.sessionStartDate).format("DD-MM-YYYY");
    let presentDate = moment().format("DD-MM-YYYY");

    let endTime = moment(sessionTime)
      .add(sessionDuration + 1, "hours")
      .format("DD-MM-YYYY HH:mm A");
    if (
      sessionYear > currentYear ||
      (sessionYear == currentYear && sessionMonth > currentMonth)
    ) {
      return true;
    } else if (currentMonth == sessionMonth) {
      if (presentDate > sessionDate) {
        return false;
      } else if (sessionDate === presentDate) {
        if (presentTime >= sessionStartTime && endTime >= presentTime) {
          return true;
        } else if (presentTime < sessionStartTime) {
          return true;
        } else {
          return false;
        }
      } else if (presentDate < sessionDate) {
        return true;
      }
    } else if (sessionYear == currentYear && sessionMonth < currentMonth) {
      return false;
    }
  };
  const testClipVisibility = (item) => {
    let testYear = moment(item?.sessionStartDate).format("YYYY");
    let currentYear = moment().format("YYYY");
    let currentMonth = moment().format("MM");
    let testMonth = moment(item?.sessionStartDate).format("MM");
    if (testYear > currentYear) return false;
    else if (testYear == currentYear && testMonth > currentMonth) return false;
    else
      return (
        moment().format("DD-MM-YYYY HH:mm A") >
          moment(
            moment(
              moment(item?.sessionStartDate).format("DD-MM-YYYY HH:mm A"),
              "DD-MM-YYYY HH:mm A"
            )
              .add(item?.sessionDuration, "hours")
              .format("DD-MM-YYYY HH:mm A"),
            "DD-MM-YYYY HH:mm A"
          )
            .add(60, "minutes")
            .format("DD-MM-YYYY HH:mm A") && item?.sessionStatus === "SCHEDULED"
      );
  };
  const roundUP = (num, decimalPlaces = 0) => {
    var p = Math.pow(10, decimalPlaces);
    var n = num * p * (1 + Number.EPSILON);
    return Math.round(n) / p;
  };
  const handleView = (videourl,videoArray,cohortAdminId) => {
    setVideoUrl(videourl);
    setShowVideo(true);
    if(videoArray !== undefined && videoArray!== null && videoArray !== "" &&  videoArray?.length > 0)
    setVideoArr(videoArray);
    if(cohortAdminId == loggedIn?.id || loggedIn?.role == "Admin")
    {
      setCanDelete(true)
    }
    else{
      setCanDelete(false)
    }
  };
  return (
    <>
      <div
        // className="mentorlistmaindiv"
        className="chrtgrpsessionadmindashmaindiv"
        style={{backgroundColor:"white"}}
      >
        <div
          className="dashboard-main2 cohortgroupsessionsdiv"
          style={{ background: "none" }}
        >
          <div
            className="MentorDashboard-CreateCohort"
            style={{ display: "none" }}
          >
            <div
              className="dashboard-bottom-btn4 topbackbtnmentorlist"
              style={{ background: "transparent", border: "none" }}
            >
           <BasicModal
                videoUrl={videoUrl}
                open={showVideo}
                setOpen={setShowVideo}
                videoList={videoArr}
                canDelete={canDelete}
              />
              {sessionModalOpen && (
                <SessionsModal
                  newCohortid={newCohortid}
                  clickModaldata={clickModaldata}
                  modalVisibility={sessionModalOpen}
                  setModalVisibility={setSessionModalOpen}
                  modalData={sessionModalData}
                  setModalOpen={setModalOpen}
                  openEditModal={setEditModalVisibility}
                  // parentData={setRefreshPage}
                  fromModule="groupSessions"
                  allMentorList={allMentorList}
                  allStartupList={allStartupList}
                  onBroadcastSelectionChange={onBroadcastSelectionChange}
                  setTaggingList={setTaggingList}
                  taggingList={taggingList}
                  setShowVideo={setShowVideo}
                  setVideoUrl={setVideoUrl}
                  fromPage="groupPage"
                  refreshPage={setRefreshPage}
                />
              )}
              {modalOpen && (
                <CohortSummaryModal
                  setModalVisibility={setModalOpen}
                  fromModule={fromModule}
                  modalVisibility={modalOpen}
                  cohortId={modalData}
                  fromPage={"cohortSessions"}
                  groupSessionId={cohortGroupSessionId}
                />
              )}
              <ModalVisible
                modalOpen={scheduleModalOpen}
                allMentorList={allMentorList}
                allStartupList={allStartupList}
                // mentorshipId={params.mentorshipId}
                setModalOpen={setScheduleModalOpen}
                onBroadcastSelectionChange={onBroadcastSelectionChange}
                setTaggingList={setTaggingList}
                taggingList={taggingList}
                refreshPage={setRefreshPage}
                EditModalValue={false}
                openEditModal={setEditModalVisibility}
              />
            </div>
            {sessionMomModalOpen && sessionMomModalOpen === true && (
              <SessionGroupFeedbackModal
                modalVisibility={sessionMomModalOpen}
                setModalVisibility={setSessionMomModalOpen}
                postFeedBack={cohortSessionNotesGiveFeedBack}
                viewMode={feedbackMode} //true if view feedback, false if post feedback
                modalData={sessionMomChildData}
                parentData={setRefreshPage}
                updateStatus={statusGroupSession}
                fromPage={"groupPage"}
                cohortGroupId={cohortGroupSessionId}
                modalData2={sessionModalData}
              />
            )}

            <div className="cohort-Application top-btn mainfirstcohortbtndiv newuserTooltip mt-4 mr-2">
              <img
                onClick={() => {
                  handleLoginClick();
                }}
                height="auto"
                className=""
                style={{ visibility: "hidden" }}
                src={createCohort}
                alt="Slide 1 Mockup 6"
              />
              <div
                className="centred mainfirstcohortbtn"
                style={{ left: "48%" }}
              >
                Create
                <br /> A Cohort
              </div>
              <span
                className="tooltiptext  tooltip-bottom"
                style={{
                  left: "76px",
                  top: "95px",
                  width: "auto",
                  padding: "3px 12px",
                }}
              >
                Click to Create A Cohort
              </span>
            </div>
          </div>
          <div className="iconWith-heading cohortappiconwith">
            <div style={{ width: "100%" }}>
              <h3
                className="sub-heading fadeInDown wow"
                style={{ color: "#262838", fontWeight: 600, fontSize: "28px"}}
              >
                MAARG Portal by Startup India
              </h3>
              <h3 className="dashboard-sub-heading fadeInDown wow">
               COHORT SESSION RECORDINGS
              </h3>
            </div>
            <div
              className="tooltipshow eyeIcon"
              // onClick={() => {
              //   // html.style.overflow = "hidden";

              //   if (html.style.overflow == "auto") {
              //     html.style.overflow = "hidden";
              //   } else {
              //     html.style.overflow = "auto";
              //   }
              // }}
            >
              <div className="newuserTooltip">
                <img
                  className="iconbtn top-btn"
                  src={iconTooltip}
                  onClick={() => {
                    setModalIsOpenToTrue();
                    if (html.style.overflow == "auto") {
                      html.style.overflow = "hidden";
                    } else {
                      html.style.overflow = "auto";
                    }
                  }}
                  width={60}
                />{" "}
                <span
                  className="tooltiptext tooltip-bottom "
                  style={{ width: "130px", top: "50px", left: "20px" }}
                >
                  View Instructions
                </span>
              </div>
            </div>
            {isShown && (
              <div>
                <AnimeList
                  setModalIsOpenToTrue={setModalIsOpenToTrue}
                  Heading={Heading}
                  InstructionswithRole={InstructionswithRole}
                  SelectPage={SelectPage}
                />
              </div>
            )}
          </div>
        </div>
        

        <div className="col-md-11 display-center mobileviewcohortappli">
          <div className="filter-row filter-row-common filterDivMentorapp" style={{marginTop:"1rem"}}>
            <div>
              <form className="formContainer">
                <div
                  className="row desktopFilterRow"
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    flexDirection: "row",
                  }}
                >
                  <div className="col-md-9 col-sm-12 d-flex filter-bigDiv filtergroupsession" style={{marginTop:"1rem"}}>
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip allstartuplistforsame">
                      <Select
                        required={true}
                        id="cohortorgname"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="cohortorgname"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.cohortorgname}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              cohortorgname: e.value == "select" ? null : e,
                              cohortId: null,
                            };
                          });
                          setFilterCohortId(e.value);
                          if (e.value === "select" || e.value === "Select")
                            setSearchCohortId("");
                          else setSearchCohortId(e.value);
                        }}
                        options={cohortnameList}
                        placeholder="Cohort Name"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "90px", top: "45px", width: "150px" }}
                      >
                        Search Cohort Name
                      </span>
                    </div>
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip ">
                      <Select
                        required={true}
                        id="cohortId"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="cohortId"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.cohortId}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              cohortId: e.value == "select" ? null : e,
                              cohortorgname: null,
                            };
                          });
                          setFilterCohortId(e.value);
                          if (e.value === "select" || e.value === "Select")
                            setSearchCohortId("");
                          else setSearchCohortId(e.value);
                        }}
                        options={cohortnameId}
                        placeholder="Cohort ID"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "90px", top: "45px", width: "130px" }}
                      >
                        Search Cohort ID
                      </span>
                    </div>
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip ">
                      <Select
                        required={true}
                        id="cohortId"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="cohortId"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.cohortId}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              cohortId: e.value == "select" ? null : e,
                              cohortorgname: null,
                            };
                          });
                          setFilterCohortId(e.value);
                          if (e.value === "select" || e.value === "Select")
                            setSearchCohortId("");
                          else setSearchCohortId(e.value);
                        }}
                        options={cohortnameId}
                        placeholder="Session Title"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "90px", top: "45px", width: "130px" }}
                      >
                        Session Title
                      </span>
                    </div>
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip ">
                    <Grid item xs={12} md={11} sm={12}>
                    <Box
                      style={{
                        border: "1px solid rgba(0,0,0,0.3)",
                        borderRadius: "4px",
                        display: "flex",
                        padding: "5px 10px",
                        maxHeight: "2.35rem",
                        minWidth:"14rem",
                      }}
                    >
                      <InputBase
                        ampm={true}
                        // label="hh:mm"
                        placeholder="Date"
                        type="date"
                        style={{
                          fontFamily: "Montserrat",
                          fontWeight: "bold",
                          fontSize: "16px",
                          color: "rgba(0,0,0,0.5)",
                          fontWeight:"400",
                          width: "100%",
                        }}
                        value={time}
                        onChange={(e) => {
                          const first = e.target.value.slice(0, 2);
                          const second = e.target.value.slice(3);
                          const curH = new Date().getHours();
                          const curM = new Date().getMinutes();
                          if (!date) {
                            setTimeError("Enter Date First");
                            return;
                          }
                          if (moment().format("YYYY-MM-DD") === date) {
                            if (parseInt(first) < parseInt(curH)) {
                              setTimeError("You cannot set a past time");
                              return;
                            } else if (parseInt(first) === parseInt(curH)) {
                              if (parseInt(second) < parseInt(curM)) {
                                setTimeError("You cannot set a past time");
                                return;
                              }
                            }
                          }
                          setTime(e.target.value);
                          setTimeErrorBoolean(false);
                          setTimeError("");
                          setError(null);
                        }}
                      />
                    </Box>
                    {timeError && (
                      <Typography
                        variant="caption"
                        style={{ color: "red", fontFamily: "Montserrat" }}
                      >
                        {timeError}
                      </Typography>
                    )}
                  </Grid>
                      {/* <Select
                        required={true}
                        id="cohortId"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="cohortId"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.cohortId}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              cohortId: e.value == "select" ? null : e,
                              cohortorgname: null,
                            };
                          });
                          setFilterCohortId(e.value);
                          if (e.value === "select" || e.value === "Select")
                            setSearchCohortId("");
                          else setSearchCohortId(e.value);
                        }}
                        options={cohortnameId}
                        placeholder="Date"
                      /> */}
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "90px", top: "45px", width: "130px" }}
                      >
                        Search by Date
                      </span>
                    </div>
                  </div>

                  <div className="apply-section d-flex justify-content-start col-md-1 col-sm-12" style={{marginTop:"1rem"}}>
                    <div className="newuserTooltip">
                      <Button
                        onClick={getTableDataSearch}
                        text="GO"
                        className="filter-button top-btn newcoloredbtn startupColorBtn"
                        style={{ minHeight: "3rem" }}
                      ></Button>
                      <span className="tooltiptext filterAdmin  tooltip-bottom filterAfter">
                        Click to Apply Filters
                      </span>
                    </div>
                  </div>
                 
                </div>

                {/* <div className="row mobileFilterRow grpsessionadmndashfiltrmbl">
                  <div className="col-md-1 filter-text">Filter by</div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="Industry"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="industry"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.industry}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            industry: e.value == "select" ? null : e,
                          };
                        });
                        setFilterIndustry(e.value);
                      }}
                      options={getPredefineOptions?.industry_options}
                      placeholder="Industry"
                    />
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="specialization"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="specialization"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.function}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            function: e.value == "select" ? null : e,
                          };
                        });
                        setFilterFunction(e.value);
                      }}
                      options={getPredefineOptions?._specialisation}
                      placeholder="Function"
                    />
                  </div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="stage"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="stage"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.stage}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            stage: e.value == "select" ? null : e,
                          };
                        });
                        setFilterStage(e.value);
                      }}
                      options={getPredefineOptions?.stage_of_startup_options}
                      placeholder="Stage"
                    />
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="country"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="country"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.country}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            country: e.value == "select" ? null : e,
                          };
                        });

                        setFilterCountry(e.label);

                        if (e.label === "India") {
                          setNewCountrySelect(true);
                          setFilterState("");
                        } else {
                          setNewCountrySelect(false);
                          setFilterState("");
                        }
                        setNewStateOptions("");
                      }}
                      options={newCountryOptions}
                      placeholder="Country"
                    />
                  </div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="state"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="state"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.state}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            state: e.value == "select" ? null : e,
                          };
                        });
                        setFilterState(e.value);
                      }}
                      options={newStateOptions}
                      placeholder="State"
                    />
                  </div>
                  <div
                    className="col-md-1 apply-section"
                    style={{ color: "transparent" }}
                  >
                    <Button className="green-btn filter-btn" text="Apply" />
                  </div>
                </div> */}
              </form>
            </div>
          </div>
            <div className="totalTableCount">
              Total Session Recording : {"10"}{" "}
              &lt; {secondTable?.paginate?.currentPage} of{" "}
              {secondTable?.paginate?.numPages} &gt;{" "}
            </div>

          {listGroupSessionData && listGroupSessionData?.length > 0 ? (
            <div>
              <div className="table-container mt-2">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th
                        style={{ verticalAlign: "middle" }}
                        className="fixColumbnWidth40"
                      >
                        {" "}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            // fontSize: "12px",
                          }}
                        >
                          NO.
                        </div>
                      </th>
                      <th
                        className="fixColumbnWidth40"
                        style={{ verticalAlign: "middle" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            minWidth: "14.9rem",
                            maxWidth: "15rem",
                            // fontSize: "12px",
                          }}
                        >
                            COHORT NAME
                        </div>
                      </th>
                      <th
                        className="fixColumbnWidth40"
                        style={{
                          whitespace: "nowrap",
                          verticalAlign: "middle",
                          fontSize: "15.3px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            // fontSize: "12px",
                            minWidth:"17.9rem",
                            maxWidth:"18rem"
                          }}
                        >
                           SESSION TITLE
                        </div>
                      </th>
                      <th
                        className="fixColumbnWidth40"
                        style={{
                          whitespace: "nowrap",
                          verticalAlign: "middle",
                          fontSize: "15.3px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            // fontSize: "12px",
                            minWidth:"17.9rem",
                            maxWidth:"18rem"
                          }}
                        >
                           SESSION DATE
                        </div>
                      </th>
                      <th className="fixColumbnWidth40">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "left",
                              alignItems: "center",
                              fontSize: "15px",
                              minWidth: "6.9rem",
                              maxWidth: "7rem",
                            }}
                          >
                           SESSION INFO
                          </div>
                        </th>
                        <th className="fixColumbnWidth7">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "left",
                              alignItems: "center",
                              // fontSize: "12px",
                              whitespace:"nowrap"
                            }}
                          >
                           SESSION RECORDING
                          </div>
                        </th>
                    </tr>
                  </thead>

                  {listGroupSessionData &&
                    listGroupSessionData.map((item, index) => (
                      <>
                        <tbody>
                          <tr>
                            <td style={{ verticalAlign: "top" }}>
                              <div>
                                {index +
                                  1 +
                                  10 *
                                    (listGroupSessionPaginate.currentPage - 1)}
                              </div>
                            </td>
                            <td className="grpsessionsdetailsmbl">
                              <div>{item?.cohortApplication?.program_name}</div>
                            </td>

                            <td className="grpsessionsdetailsmbl">
                            <div>{item?.sessionTitle}</div>
                            </td>
                            <td className="grpsessionsdetailsmbl">
                              <div>
                                Date :{" "}
                                {moment(item?.sessionStartDate).format(
                                  "DD/MM/YYYY"
                                )}
                              </div>
                              <div>
                                Time :{" "}
                                {moment(item?.sessionStartDate).format(
                                  "hh:mm a"
                                )}{" "}
                                (
                                {moment
                                  .tz(
                                    item?.sessionStartDate,
                                    Intl.DateTimeFormat().resolvedOptions()
                                      .timeZone
                                  )
                                  .format("z")
                                  .includes("-")
                                  ? "GMT" +
                                    moment
                                      .tz(
                                        item?.sessionStartDate,
                                        Intl.DateTimeFormat().resolvedOptions()
                                          .timeZone
                                      )
                                      .format("z")
                                  : moment
                                      .tz(
                                        item?.sessionStartDate,
                                        Intl.DateTimeFormat().resolvedOptions()
                                          .timeZone
                                      )
                                      .format("z")}
                                )
                              </div>
                            </td>
                            <td className="grpsessionsdetailsmbl">
                                  <div
                                    className="newuserTooltip"
                                    style={{
                                      cursor: "pointer",
                                      alignItems: "end",
                                      justifyContent: "center",
                                      minWidth: "40px",
                                      display: "flex",
                                      position:"relative",
                                      top:"0.75rem"
                                    }}
                                    onClick={() => {
                                      setSessionModalOpen(true);
                                      getSessionDetails(item?.cohortGroupSessionId);
                                      setNewCohortid(item?.cohortId);
                                      setClickmodaldata(item);
                                    }}
                                  >
                                     <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  class="bi bi-info-circle"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                  <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                                </svg>
                                    <span
                                      className="tooltiptext tooltip-bottom "
                                      style={{
                                        left: "2.85rem",
                                        top: "1.75rem",
                                        width: "150px",
                                      }}
                                    >
                                      View Session Details
                                    </span>
                                  </div>
                            </td>
                            <td className="mntrinvgrpsessionmbltd">
                            <div className="newuserTooltip">
                                        <div
                                          className="color-green mt-1"
                                          style={{
                                            cursor: "pointer",
                                            whiteSpace: "nowrap",
                                            width: "fit-content",
                                          }}
                                          onClick={() => {
                                            handleView(item?.recording,item?.recordings,item?.cohortAdminId);
                                          }}
                                        >
                                          View Recording
                                        </div>
                                        <span
                                          className="tooltiptext tooltip-bottom "
                                          style={{
                                            left: "3rem",
                                            top: "2.4rem",
                                            width: "150px",
                                          }}
                                        >
                                          Play Recording
                                        </span>
                                      </div>
                            </td>
                           
                          
                           
                            
                          </tr>
                        </tbody>
                      </>
                    ))}
                </table>
                <div className="pagination-box">
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={10}
                      totalItemsCount={listGroupSessionPaginate.totalElements}
                      pageRangeDisplayed={5}
                      onChange={handlePageChange.bind(this)}
                    />
                </div>
              </div>
            </div>
          ) : (
            <div className="no-records">No Records Found</div>
          )}
          {/* <div
            className="dashboard-bottom-btn top-btn dashboardbelowBtn newuserTooltip dashboardbelowBtnagaintwo"
            style={{ margin: "auto" }}
            onClick={() => {
              history.push({
                pathname: "/dashboard",
                state: {
                  fromModule: "cohortMentorApplication",
                },
              });
              props.setSelectedMenu("cohortProgram");
            }}
          >
            <p style={{ cursor: "pointer" }} className="text-white3">
              VIEW COHORT PROGRAMS
            </p>
            {!sessionHoursBtnPressed && (
              <span
                className="tooltiptext tooltip-bottom"
                style={{ left: "410px", top: "60px", width: "220px" }}
              >
                Click to View Cohort Programs
              </span>
            )}
          </div> */}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    startUpApplication: state.StartUpReducer.StartUpApplications.data,
    startUpApplicationPagineate:
      state.StartUpReducer.StartUpApplications.paginate,
    getCounterStartUp: state.StartUpReducer.getCountersStartUpList.data,
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    getNamesListData: state.AdminMentorReducer.getNamesList?.data,
    getTableData: state.MentorReducer.getCohortMentorList.data,
    getTableDataPaginate: state.MentorReducer.getCohortMentorList.paginate,
    getTableCounterData:
      state.AdminMentorReducer.getCohortApplicationCounter.data,
    getStepperData: state.AdminMentorReducer.getStepperList.list,
    listGroupSessionPaginate:
      state.MentorReducer.listCohortGroupSession.paginate,
    listGroupSessionData: state.MentorReducer.listCohortGroupSession.data,
    detailsGroupSessionData: state.MentorReducer.detailsCohortGroupSession.data,
    invitedSessionList: state.MentorReducer.listSessionMemberList.data,
    invitedSessionListPaginate:
      state.MentorReducer.listSessionMemberList.paginate,
    groupSessionCounter:
      state.MentorReducer.listCohortGroupSessionCounters.data,
    sessionFeedBackData: state.MentorReducer.cohortViewFeedBack.data,
    sessionNotesFeedBackData:
      state.MentorReducer.cohortSessionNotesViewFeedBack,
    cohortGroupSessionHoursData: state.MentorReducer.cohortGroupSessionHours,
    cohortGroupSessionHoursFilteredData:
      state.MentorReducer.cohortGroupSessionHoursFilter,
    cohortCounterData: state.AdminMentorReducer.adminDashCohortCounter,
  };
};
export default connect(mapStateToProps, {
  getPredefineOptionsList,
  getNamesList,
  getCohortApplicationCounter,
  getStepperTooltipData,
  listGroupSession,
  detailsGroupSession,
  invitedSessionMembersList,
  statusGroupSession,
  listGroupSessionCounter,
  cohortSessionNotesGiveFeedBack,
  cohortSessionNotesViewFeedBack,
  cohortGroupSessionHours,
  getAdminDashCohortGraphData,
  cohortGroupSessionHoursFilter,
})(withRouter(CohortRecordingList));
